export function createElement(name) {
    return document.createElementNS('http://www.w3.org/2000/svg', name);
}



//////////////////
// WEBPACK FOOTER
// ./~/zrender/lib/svg/core.js
// module id = 210
// module chunks = 0